/**
 * The type of `Dialog`.
 */
export enum DialogType {
    NarratorDialog,
    PlayerDialog,
    PlayerOptionDialog,
    NPCDialog,
    ChapterEnd,
}
